/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Add.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import AddAction from './AddAction/view.js'
import CancelAction from './CancelAction/view.js'
import City from './City/view.js'
import Company from './Company/logic.js'
import DoingBusinessAs from './DoingBusinessAs/logic.js'
import Info from 'DesignSystem/Info/view.js'
import ModalContent from 'DesignSystem/ModalContent/view.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PhoneNumber from './PhoneNumber/view.js'
import React from 'react'
import State from './State/logic.js'
import Street from './Street/logic.js'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import Website from './Website/view.js'
import Zip from './Zip/view.js'
import { css } from "emotion"
Company.displayName = 'CompanyLogic'
DoingBusinessAs.displayName = 'DoingBusinessAsLogic'
State.displayName = 'StateLogic'
Street.displayName = 'StreetLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 50})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
marginTop: 50})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
marginTop: 30})
styles.Horizontal5 = css({label: 'Horizontal5',
  flexDirection: "row",
marginTop: 30})

export default function Add({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Add.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/ModalHeader`}
 text="Add a location"
>
{childProps => (
<React.Fragment>
<AddAction
{...childProps}
 data-testid="Add.AddAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/AddAction`}
/>
<CancelAction
{...childProps}
 data-testid="Add.CancelAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/CancelAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<ModalContent
 data-testid="Add.ModalContent"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/ModalContent`}
>
{childProps => (
<React.Fragment>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Selected company"
/>
<div
 data-testid="Add.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal}`}
>
<Company
 data-testid="Add.Company"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/Company`}
/>
</div>
<div
 data-testid="Add.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal1}`}
/>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Doing business as (DBA)"
/>
<div
 data-testid="Add.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal2}`}
>
<DoingBusinessAs
 data-testid="Add.DoingBusinessAs"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/DoingBusinessAs`}
/>
</div>
<Info
{...childProps}
 data-testid="Add.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/Info`}
 fontSize={12}
 marginTop={8}
 marginLeft={4}
 text="To use a new location name add it as a DBA in the company details"
/>
<div
 data-testid="Add.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal3}`}
>
<PhoneNumber
 data-testid="Add.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/PhoneNumber`}
/>
<Website
 data-testid="Add.Website"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/Website`}
/>
</div>
<div
 data-testid="Add.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal4}`}
>
<Street
 data-testid="Add.Street"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/Street`}
/>
<City
 data-testid="Add.City"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/City`}
/>
</div>
<div
 data-testid="Add.Horizontal:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
 className={`views-block ${styles.Horizontal5}`}
>
<State
 data-testid="Add.State"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/State`}
/>
<Zip
 data-testid="Add.Zip"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add"
viewPath={`${viewPath}/Zip`}
/>
</div>
</React.Fragment>
)}
</ModalContent>
{children}
</React.Fragment>)
}